import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    itemInfo: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      padding: "0px",
      flex: 1,
    },
    itemInfoDetail: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      margin: 0,
      "@media screen and (max-width: 768px)": {
        fontSize: "12px",
        lineHeight: "16px",
      },
    },
    itemName: {
      margin: 0,
      padding: "0 0 4px",
    },
  },
  { name: "N0ItemCard" },
);

export { useStyles };
